import {useEffect, useState} from "react";

const useSse = (url, enabled = true) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (!enabled) return;

        const eventSource = new EventSource(url);

        eventSource.onmessage = (event) => {
            setData(JSON.parse(event.data));
        }

        eventSource.onerror = (error) => {
            console.error("Error to load SOS information", error);
        }

        return () => eventSource.close();
    }, [url, enabled]);

    return data;
}

export default useSse;